import { toFlatField } from '../oasis-types';
export const CardiovascularVersioned = {
    cardiovascular: { e1: { alias: 'cardiovascular', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
};
export const Cardiovascular = toFlatField(CardiovascularVersioned);
